import * as React from 'react';
import { Divider, Stack } from '@mui/material';
import { useListContext } from 'react-admin';

import { Note } from './Note';

export const NotesIterator = () => {
    const { data } = useListContext();

    if (!data) return null;

    return (
        <Stack mt={2} gap={1}>
            {data.map((note, index) => (
                <React.Fragment key={index}>
                    <Note
                        note={note}
                        isLast={index === data.length - 1}
                        key={index}
                    />
                    {index < data.length - 1 && <Divider />}
                </React.Fragment>
            ))}
        </Stack>
    );
};
